import { useTranslation } from 'react-i18next'
import { IdCard, Modal, Stepper } from '@/components/molecules'
import type { StepperItem } from '@/components/molecules'
import { rentersDefaultIdCardImage } from '@/shared/assets'
import { useOnboardingRentersPage } from './page.onboarding-renters.hook'
import { PaymentLayout } from '@/pages/payment/page.payment'
import { RentersStepOnePage } from './step-one/page.onboarding-renters-step-one'
import { RentersStepTwoPage } from './step-two/page.onboarding-renters-step-two'
import { RentersStepThreePage } from './step-three/page.onboarding-renters-step-three'
import { RentersStepFourPage } from './step-four/page.onboarding-renters-step-four'
import { RentersStepFivePage } from './step-five/page.onboarding-renters-step-five'
import { RentersStepSixPage } from './step-six/page.onboarding-renters-step-six'

export function OnboardingRentersPage() {
  const { t } = useTranslation()
  const {
    policyId,
    dwellingType,
    startAt,
    ownerName,
    policiesLoading,
    isModalOpen,
    closeModal,
    currentStep,
    handleNext,
    handleBack,
    additionalCoverageTypes,
    isEnglish,
  } = useOnboardingRentersPage()

  const steps: StepperItem[] = [
    {
      label: t('onboarding.modal.whoWeAreLabel'),
      children: (
        <RentersStepOnePage
          policyId={policyId}
          dwellingType={dwellingType}
          startAt={startAt}
          ownerName={ownerName}
          isLoading={policiesLoading}
          onContinue={handleNext}
        />
      ),
    },
    {
      label: t('onboarding.renters.stepTwo.stepLabel'),
      children: (
        <RentersStepTwoPage onContinue={handleNext} onBack={handleBack} />
      ),
    },
    {
      label: t('onboarding.renters.stepThree.stepLabel'),
      children: (
        <RentersStepThreePage
          policyId={policyId}
          startAt={startAt}
          onContinue={handleNext}
          onBack={handleBack}
          dwellingType={dwellingType}
          isLoading={policiesLoading}
          additionalCoverageTypes={additionalCoverageTypes}
        />
      ),
    },
    {
      label: t('onboarding.renters.stepFour.stepLabel'),
      children: (
        <RentersStepFourPage onContinue={handleNext} onBack={handleBack} />
      ),
    },
    {
      label: t('onboarding.renters.stepFive.stepLabel'),
      children: (
        <RentersStepFivePage onContinue={handleNext} onBack={handleBack} />
      ),
    },
    {
      label: t('onboarding.renters.stepSix.stepLabel'),
      children: (
        <RentersStepSixPage onContinue={handleNext} onBack={handleBack} />
      ),
    },
  ]

  return (
    <>
      <PaymentLayout />
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        className={`flex h-full justify-center max-md:max-h-[calc(100dvh-var(--modal-mobile-offset)-var(--sat))] md:h-full ${isEnglish ? 'md:max-h-131.5' : 'md:max-h-145'} md:max-w-237`}
        chilrenClassName="max-h-auto"
      >
        <div
          className="flex h-full w-full flex-col px-6 pt-8 pb-10 md:pt-19.5 md:pr-16.25 md:pb-17 md:pl-24.5"
          data-testid="onboarding-renters-modal"
        >
          <div
            className={`grid transition-[grid-template-rows] delay-(--default-transition-duration) duration-(--default-transition-duration) ease-(--default-transition-timing-function) md:hidden ${currentStep === 0 ? '-order-1 grid-rows-[1fr] pt-5' : 'grid-rows-[0fr] pt-0 opacity-0 delay-0'}`}
          >
            <div
              className={`flex min-h-0 justify-center overflow-hidden ${currentStep === 0 ? 'mb-6' : 'mb-0'}`}
            >
              <IdCard
                variant="with-photo"
                photoUrl={rentersDefaultIdCardImage}
                planName={dwellingType}
                ownerName={ownerName}
                policyId={policyId}
                startDate={startAt}
                isLoading={policiesLoading}
                isMobile={false}
                className="aspect-auto max-h-51.5 w-full max-w-81.5 self-center sm:aspect-326/206"
                hidePhotoBackground
              />
            </div>
          </div>
          <Stepper
            items={steps}
            currentStep={currentStep}
            className={`min-h-0 flex-1 md:gap-6 ${currentStep !== 0 ? '' : '-order-1'}`}
          />
        </div>
      </Modal>
    </>
  )
}
